module.exports = __webpack_public_path__ + "img/bgPurplerectangle.820b5472.png";